import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { noop } from '@prisjakt/ui-base';
import actions from './actions/mobile-menu';
import categoryType from './shared/types';

import SidebarMobile from '../sidebar/components/sidebar-mobile';

const MobileNavigation = props => {
  const {
    open,
    history,
    isTraversingUpwards,
    categories,
    closeMenu,
    changeCategories,
    selectHistory,
  } = props;

  return (
    <SidebarMobile
      onClose={closeMenu}
      menuHistory={history}
      onSelectHistory={selectHistory}
      categories={categories}
      isTraversingUpwards={isTraversingUpwards}
      onMenuChange={changeCategories}
      open={open}
    />
  );
};

const { func, bool } = PropTypes;
MobileNavigation.propTypes = {
  open: bool,
  history: categoryType,
  isTraversingUpwards: bool,
  categories: categoryType,
  closeMenu: func,
  navigateFromMobileMenu: func,
  selectHistory: func,
  changeCategories: func,
  showSidebar: bool,
};

MobileNavigation.defaultProps = {
  open: false,
  history: [],
  isTraversingUpwards: false,
  categories: [],
  closeMenu: noop,
  navigateFromMobileMenu: noop,
  selectHistory: noop,
  changeCategories: noop,
  showSidebar: false,
};

const mapStateToProps = state => ({
  open: state.areas.navigation.mobileMenu.open,
  history: state.areas.navigation.mobileMenu.history,
  isTraversingUpwards: state.areas.navigation.mobileMenu.isTraversingUpwards,
  categories: state.areas.navigation.mobileMenu.categories,
});

const dispatchProps = {
  closeMenu: actions.closeMenu,
  navigateFromMobileMenu: actions.navigateFromMobileMenu,
  changeCategories: actions.changeCategories,
  selectHistory: actions.selectHistory,
};

export default connect(mapStateToProps, dispatchProps)(MobileNavigation);
